import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FundamentalChartModule } from '../fundamental-chart/fundamental-chart.module';
import * as i0 from "@angular/core";
export class BareFundChartWrapperModule {
}
BareFundChartWrapperModule.ɵfac = function BareFundChartWrapperModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || BareFundChartWrapperModule)(); };
BareFundChartWrapperModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: BareFundChartWrapperModule });
BareFundChartWrapperModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, BrowserModule, FundamentalChartModule] });
